import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatTooltip } from '@angular/material/tooltip';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzPopconfirmModule } from 'ng-zorro-antd/popconfirm';
import { NzPopoverModule } from 'ng-zorro-antd/popover';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { take } from 'rxjs';
import { Resume } from '../../../core/resume/resume';
import { ResumeService } from '../../../core/resume/resume.service';
import { PortraitSelectComponent } from '../portrait-select/portrait-select.component';

@Component({
  selector: 'app-edit-customer-portrait',
  standalone: true,
  imports: [
    CommonModule,

    FormsModule,

    NzModalModule,
    NzButtonModule,
    NzInputModule,
    NzPopconfirmModule,
    NzTagModule,
    NzCollapseModule,
    NzTagModule,
    MatTooltip,
    NzPopoverModule,
    NzTabsModule,
    NzDividerModule,

    PortraitSelectComponent,
  ],
  templateUrl: './edit-customer-portrait.component.html',
  styleUrl: './edit-customer-portrait.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EditCustomerPortraitComponent {
  @Input() isVisible = false;
  @Output() isVisibleChange = new EventEmitter<boolean>();

  onIsVisibleChange(isVisible: boolean) {
    this.isVisibleChange.emit(isVisible);
  }

  constructor(private resumeService: ResumeService) {}

  ngOnInit() {
    this.portraitUrl = this.resume?.subData.content?.portraitImageUrl || '';
  }

  onCancelClick() {
    this.isVisible = false;
    this.isVisibleChange.emit(this.isVisible);
  }

  onSubmitClick() {
    if (this.resume) {
      this.resume.subData.content!.portraitImageUrl = this.portraitUrl;
      this.resumeService.updateResume$(this.resume).pipe(take(1)).subscribe();
    }

    this.isVisible = false;
    this.isVisibleChange.emit(this.isVisible);
  }

  @Input() resume?: Resume;

  portraitUrl: string = '';
}
